import whaleboneApi, { EncodeWheleboneResponse } from "../../api/whalebone/whaleboneApi";
import { useMutateApi } from "../hooks";

type UseWhaleboneEncodeParams = {
  onSuccess?: (data: any, variables: any) => void;
  onError?: (error: unknown) => void;
};
export const useWhaleboneEncode = ({
  onSuccess,
  onError,
}: UseWhaleboneEncodeParams = {}) =>
  useMutateApi<EncodeWheleboneResponse, any>({
    fetch: (variables) => whaleboneApi.postWhaleboneEncode(variables),
    key: ["whaleboneApi.postWhaleboneEncode"],
    onSuccess,
    onError,
  });